import { Input } from 'libs/ui';
import { CSSObject, styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const InputStyped = styled(Input)({
  '.MuiInputBase-root': {
    height: 32,

    '.MuiInputBase-input': {
      fontSize: 14,
      padding: 4,

      '&::placeholder': {
        fontSize: 14,
        color: Colors.gray600,
      },
    } as CSSObject,
  },
});
